import { call } from 'redux-saga/effects';
export const safeWrapper = (handler = null, saga, ...args) =>
    function* (action) {
        try {
            yield call(saga, ...args, action);
        } catch (err) {
            yield call(handler, ...args, err, action);
        }
    };
